import React, { useState } from "react";
import { Button, Form, Radio, Space, DatePicker } from "antd";
import LeftSide_Step1 from "../../images/icons/leftside_step3.jpg";
import { API_BASE_URL } from "../../utils/constants";
import moment from "moment";
import axios from "axios";
import bg_onboarding from "../../images/icons/bg_onboarding.png";

function Step3(props) {
  const {   moveBackStep, onFinish, formData } = props;
  const [syncTypeValue, setSyncTypeValue] = useState(formData.syncType);
  const [isSyncButtonEnable, setIsSyncButtonEnable] = useState(
    formData.inventoryStartDate == "" ? false : true
  );
  const [form] = Form.useForm();

  const onChange = (e) => {
    setSyncTypeValue(e.target.value);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  function handleDatePickerChange(date, dateString) {
    if (date) {
      setIsSyncButtonEnable(true);
    }
  }

  const manualSyncOfData = (e) => {
    axios
      .post(API_BASE_URL + "/api/qbo/saveAccountSettings", formData)
      .then((res) => {
        console.log("res.data after settings saved ", res.data);
      })
      .catch((err) => {
        console.log("err in catch of insert into AccountSeetings", err);
      });
  };

  return (
    <div
      className="
    h-screen w-full  bg-cover bg-center lg:bg-cover lg:bg-no-repeat bg-no-repeat
    grid grid-cols-12"
      style={{
        backgroundImage: `url(${bg_onboarding})`,
        flexBasis: 0,
        flexGrow: 3,
      }}
    >
      {/* 1st half */}
      <div className="col-span-6 ">
        {/* <img className="w-full h-screen" src={LeftSide_Step1}  alt="step3 image"/> */}
      </div>

      {/* 2nd half */}
      <div className="col-span-6 flex items-center justify-center w-full ">
        <div className="w-full mx-10">
          <div className="  border-2 bg-white rounded-lg">
            <div className="mx-5">
              <p className="font-raleway font-normal text-xs h-4 mt-6">
                Step 3/4
              </p>
              <h1 className="font-raleway font-bold text-3xl h-4 mt-4 leading-6">
              Select Sync Type
              </h1>
              <p className="text-label ">
              Define the{" "}
                        <span className="font-bold">
                          Integration Starting Date{" "}
                        </span>
                        to sync data between your Store and QuickBooks Online account. 

                      </p>
              <Form
                form={form}
                name="sync_settings"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                scrollToFirstError
                initialValues={{
                  inventoryStartDate: formData.inventoryStartDate,
                  syncType: formData.syncType,
                }}
                style={{}}
              >
                <div className="w-full  ">
                   
                  <div className="mt-6">
                     
                   <Form.Item name="syncType">
                        <Radio.Group onChange={onChange} value={syncTypeValue}>
                          <Space direction="vertical">
                            <Radio value={"manualSync"}>
                              <h1 className="font-raleway text-xs font-semibold">
                                Manual Sync
                              </h1>
                              <p className="font-raleway text-small_label text-black_text_light">
                              Set Manual Sync as default if you want to sync the historical data between your Shopify Store and Quickbooks Online. Works best for companies who need more control over their data.
                              </p> 
                              {/* <p className="font-raleway   text-small_label text-black_text_light">
                                This option is designed for businesses who want
                                more control over syncing.
                              </p> */}

                              {syncTypeValue === "manualSync" && (
                                <div className="  flex gap-10 ">
                                  <p className="font-raleway text-small_label text-black_text_light">
                                    <span className="text-red-600 text-2xl">
                                      *
                                    </span>
                                    Integrations Starting Date:
                                  </p>

                                  <Form.Item
                                    name="inventoryStartDate"
                                    rules={[
                                      {
                                        required: syncTypeValue == "manualSync",
                                        type: "object",
                                        message: "Please select Start Date!",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      className="content-start"
                                      style={{
                                        width: 150,
                                      }}
                                      placeholder="Inventory Start Date"
                                      disabledDate={(current) => {
                                        let customDate = moment()
                                          .subtract(60, "days")
                                          .format("YYYY-MM-DD");
                                        return (
                                          current <
                                          moment(customDate, "YYYY-MM-DD")
                                        );
                                      }}
                                      onChange={(date, dateString) =>
                                        handleDatePickerChange(
                                          date,
                                          dateString,
                                          1
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  <Form.Item></Form.Item>

                                  
                                </div>
                              )}
                            </Radio>

                            <Radio value={"liveSync"}>
                              <h1 className="text-xs font-semibold">
                                Live Sync
                              </h1>
                              <p className=" font-raleway text-small_label text-black_text_light">
                              Set Live Sync as default if you want to automate the sync between your Shopify Store and QuickBooks Online. Works best for companies who need to save more resources.{" "}
                              </p>
                              {/* <p className=" font-raleway text-small_label text-black_text_light">
                                This option is designed for businesses who want
                                more control over syncing.
                              </p> */}
                            </Radio>
                            <Radio value={"both"}>
                              <h1 className="text-xs font-semibold">Manual and Live Sync</h1>
                              <p className=" font-raleway text-small_label text-black_text_light">
                              Set this option as default if you want to enable both live and manual sync. Decide which data you want to sync manually while the usual data will be synced automatically.
                              </p>

                              {syncTypeValue === "both" && (
                                <div className="  flex gap-10">
                                  <p className="font-raleway text-small_label text-black_text_light">
                                    <span className="text-red-600 text-2xl">
                                      *
                                    </span>
                                    Integrations Starting Date:
                                  </p>

                                  <Form.Item
                                    name="inventoryStartDate"
                                    rules={[
                                      {
                                        required: syncTypeValue == "both",
                                        type: "object",
                                        message: "Please select Start Date!",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      className=""
                                      style={{
                                        width: 150,
                                      }}
                                      placeholder="Inventory Start Date"
                                      disabledDate={(current) => {
                                        let customDate = moment()
                                          .subtract(60, "days")
                                          .format("YYYY-MM-DD");
                                        return (
                                          current <
                                          moment(customDate, "YYYY-MM-DD")
                                        );
                                      }}
                                      onChange={(date, dateString) =>
                                        handleDatePickerChange(
                                          date,
                                          dateString,
                                          1
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              )}
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>   
                  </div>

                   

                  
                
                </div>     

                <div className="flex gap-6 justify-end mt-8 mb-9">
                  <Button
                    loading={false}
                    className="  w-24"
                    onClick={moveBackStep}
                  >
                    Back
                  </Button>
                  <Button className="  w-24" type="primary" htmlType="submit">
                    Next
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Step3;
